export default __webpack_public_path__ + "static/media/School_2.3d1396d5.jpg";